<template>
  <eg-dropdown
    :disabled="disabled"
    :size="size"
    :text="value ? value.name : $t('rubrics.selectRubric')"
    :menu-class="menuClass"
  >
    <eg-b-dropdown-text v-if="groupedRubrics.length === 0">
      {{ $t("rubrics.rubricSelectEmpty") }}
    </eg-b-dropdown-text>
    <eg-b-dropdown-group
      v-for="(rubrics, rubricType) in groupedRubrics"
      :key="rubricType"
      :header="`${rubricType} RUBRICS`"
    >
      <eg-b-dropdown-item-button
        v-for="rubricData in rubrics"
        :key="rubricData.id"
        class="dropdown-item-wrapper"
        @click="() => selectRubric(rubricData)"
      >
        {{ rubricData.name }}
      </eg-b-dropdown-item-button>
    </eg-b-dropdown-group>
  </eg-dropdown>
</template>

<script>
import EgDropdown from "@/components/global/eg_dropdown";

export default {
  components: {
    EgDropdown,
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    },
    rubrics: {
      type: Array,
      required: true,
    },
    size: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    menuClass: {
      type: String,
      default: "w-100",
    },
  },

  computed: {
    groupedRubrics() {
      const groupedRubrics = this.rubrics.reduce((grouped, rubric) => {
        const rubricType = rubric.type.toUpperCase();

        if (!grouped[rubricType]) {
          grouped[rubricType] = [];
        }

        grouped[rubricType].push(rubric);

        return grouped;
      }, {});

      return groupedRubrics;
    },
  },

  methods: {
    selectRubric(rubric) {
      this.$emit("input", rubric);
    },
  },
};
</script>
